import {SessionConfigService} from './core/services/session-config.service';
import {firstValueFrom} from 'rxjs';

/**
 * Factory function to initialize session config before app starts.
 */
export function initializeApp(configService: SessionConfigService) {
  return () => firstValueFrom(configService.loadConfig());
}
